/**
 * UnfollowResult 骨架屏组件
 *
 * CLS 优化：为 Unfollow 搜索结果提供布局稳定的骨架屏
 *
 * 问题：点击 Start 后，搜索结果区域从无到有突然出现，导致下方内容位移
 *
 * 解决：在 loading 时显示与真实内容布局一致的骨架屏，保持容器高度稳定
 */
import { Skeleton } from 'antd';
import { cn } from '@/lib/utils';

export default function UnfollowResultSkeleton() {
  return (
    <div className="w-[33.875rem] mt-14 mx-auto max-md:w-full max-md:mt-8">
      {/* 用户信息头部骨架 */}
      <div className="flex items-center justify-center">
        <Skeleton.Avatar active size={68} shape="circle" className="mr-4" />
        <div className="text-left">
          <Skeleton.Input active style={{ width: 150, height: 28, marginBottom: 6 }} />
          <div className="flex space-x-4">
            <Skeleton.Input active style={{ width: 80, height: 16 }} />
            <Skeleton.Input active style={{ width: 80, height: 16 }} />
          </div>
        </div>
      </div>

      {/* 结果显示区域骨架 */}
      <div className="w-full mt-12 mx-auto max-md:mt-8 bg-white rounded-lg shadow-md overflow-hidden">
        {/* 标签页骨架 */}
        <div className="flex border-b text-[16px] leading-5 max-md:rounded-lg max-md:overflow-hidden">
          <div className="flex-1 py-3 bg-pink-500 flex justify-center">
            <Skeleton.Input active style={{ width: 70, height: 20 }} />
          </div>
          <div className="flex-1 py-3 bg-[#f3f4f6] flex justify-center">
            <Skeleton.Input active style={{ width: 60, height: 20 }} />
          </div>
          <div className="flex-1 py-3 bg-[#f3f4f6] flex justify-center">
            <Skeleton.Input active style={{ width: 70, height: 20 }} />
          </div>
        </div>

        {/* 内容区域骨架 */}
        <div className="p-8 max-md:p-4">
          {/* 用户列表骨架 */}
          <div className="space-y-1">
            {Array.from({ length: 5 }, (_, index) => (
              <div key={index} className="flex items-center p-2">
                {/* 序号圆形 */}
                <div
                  className={cn(
                    'w-8 h-8 flex items-center justify-center rounded-full mr-3',
                    index < 3 ? 'bg-purple-200' : 'bg-gray-200'
                  )}
                />
                {/* 头像 */}
                <Skeleton.Avatar active size={40} shape="circle" className="mr-3" />
                {/* 用户名和全名 */}
                <div className="flex-grow min-w-0">
                  <Skeleton.Input active style={{ width: 120, height: 20, marginBottom: 4 }} />
                  <Skeleton.Input active style={{ width: 80, height: 16 }} />
                </div>
              </div>
            ))}
          </div>

          {/* 加载更多指示器骨架 */}
          <div className="mt-6 mb-8 flex justify-center items-center space-x-2">
            <span className="w-2 h-2 bg-gray-300 rounded-full"></span>
            <span className="w-2 h-2 bg-gray-300 rounded-full"></span>
            <span className="w-2 h-2 bg-gray-300 rounded-full"></span>
          </div>

          {/* 性别分布骨架 */}
          <div className="bg-gray-50 rounded-lg p-4">
            <Skeleton.Input active style={{ width: 150, height: 20, marginBottom: 12 }} />
            <div className="flex gap-4 max-md:flex-col">
              <div className="flex-1 h-24 bg-gray-200 rounded animate-pulse" />
              <div className="flex-1 h-24 bg-gray-200 rounded animate-pulse" />
            </div>
          </div>

          {/* 加载更多按钮骨架 */}
          <div className="mt-6 text-center">
            <Skeleton.Input active style={{ width: 280, height: 20, marginTop: 24 }} />
            <div className="mt-8 mb-4 max-md:mt-4 max-md:mb-2">
              <Skeleton.Button active style={{ width: 200, height: 44 }} />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
